module.exports = __webpack_public_path__ + "static/media/pitch-icon.3145de99.svg";